/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

// 格式化时间
function formatTime(time) {
    if (!time) return '';

    // 处理数组类型时间
    if (Array.isArray(time)) {
      // 扩展数组至6位，缺失部分补0
      const padded = time.length >= 6 
        ? [...time] 
        : [...time, ...new Array(6 - time.length).fill(0)];
      
      // 格式化各部分：年直接显示，其他部分补零至两位
      const formatted = padded.map((item, index) => {
        const num = Number(item) || 0;
        return index === 0 
          ? `${num}` 
          : `${num}`.padStart(2, '0');
      });

      return `${formatted[0]}-${formatted[1]}-${formatted[2]} ${formatted[3]}:${formatted[4]}:${formatted[5]}`;
    }

    // 使用工具函数处理非数组时间
    return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}');
  };

  function formatSimpleDate(timeData) {
    if (!timeData) return '';
    
    try {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      const yesterday = today - 24 * 60 * 60 * 1000;
      
      // 处理不同格式的日期数据
      let createTime;
      
      // 处理数组格式 [2025, 4, 9, 20, 54, 55]
      if (Array.isArray(timeData)) {
        // 注意月份需要减1，因为JavaScript中月份是0-11
        createTime = new Date(
          timeData[0],           // 年
          timeData[1] - 1,       // 月（减1）
          timeData[2],           // 日
          timeData[3] || 0,      // 时
          timeData[4] || 0,      // 分
          timeData[5] || 0       // 秒
        );
      } else if (typeof timeData === 'string') {
        // 处理字符串格式
        if (timeData.includes('T')) {
          // ISO格式: 2023-01-01T12:30:00.000Z
          createTime = new Date(timeData);
        } else if (timeData.includes('-')) {
          // 标准格式: 2023-01-01 12:30:00
          createTime = new Date(timeData.replace(' ', 'T'));
        } else {
          // 时间戳格式
          createTime = new Date(Number(timeData));
        }
      } else {
        // 如果是数字（时间戳）
        createTime = new Date(timeData);
      }
      
      // 检查创建的日期对象是否有效
      if (isNaN(createTime.getTime())) {
        console.error('无效的日期格式:', timeData);
        return String(timeData); // 返回原始数据的字符串形式
      }
      
      // 计算当前时间与创建时间的差异（毫秒）
      const timeDiff = now.getTime() - createTime.getTime();
      const minutesDiff = Math.floor(timeDiff / (60 * 1000));
      
      // 60分钟内显示"多少分钟前"
      if (minutesDiff < 60 && minutesDiff >= 0) {
        return minutesDiff === 0 ? '刚刚' : `${minutesDiff}分钟前`;
      }
      
      const createDate = new Date(createTime.getFullYear(), createTime.getMonth(), createTime.getDate()).getTime();
      
      const hours = createTime.getHours().toString().padStart(2, '0');
      const minutes = createTime.getMinutes().toString().padStart(2, '0');
      const timeFormat = `${hours}:${minutes}`;
      
      if (createDate >= today) {
        return `今天 ${timeFormat}`;
      } else if (createDate >= yesterday) {
        return `昨天 ${timeFormat}`;
      } else {
        const year = createTime.getFullYear();
        const month = (createTime.getMonth() + 1).toString().padStart(2, '0');
        const day = createTime.getDate().toString().padStart(2, '0');
        if(now.getFullYear() === createTime.getFullYear()){ 
            return `${month}-${day} ${timeFormat}`;
        }else{
            return `${year}-${month}-${day} ${timeFormat}`;
        }
      }
    } catch (error) {
      console.error('日期格式化错误:', error, timeData);
      return String(timeData); // 出错时返回原始数据的字符串形式
    }
  }

/**
 * 导出 
 **/
export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    formatTime,
    formatSimpleDate
}


// WEBPACK FOOTER //
// ./src/utils/util.js